module.exports = __webpack_public_path__ + "img/VL_05_03.5e58a946.png";